import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { Toaster } from 'sonner';
import FloatingWhatsApp from '@/components/common/FloatingWhatsApp';

// Pages
import LandingPage from '@/pages/LandingPage';
import AssessmentPage from '@/pages/AssessmentPage';
import ResultsDashboard from '@/pages/ResultsDashboard';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import SampleReportsPage from '@/pages/SampleReportsPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/assessment" element={<AssessmentPage />} />
            <Route path="/results/:assessmentId" element={<ResultsDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/sample-reports" element={<SampleReportsPage />} />
          </Routes>
          <FloatingWhatsApp />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
